import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from 'reactstrap'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import {connect} from 'react-redux'
import {closeNotAuthorized} from '../../actions/notAuthorized'

class NotAuthorizedAlert extends Component {

  constructor(props) {
    super(props)
    this.state = {isOpen: false}
  }

  static propTypes = {
    closeNotAuthorized: PropTypes.func.isRequired,
    notAuthorized: PropTypes.object.isRequired,
  }

  componentWillReceiveProps(nextProps) {
    this.setState({isOpen: nextProps.notAuthorized.isOpen})
  }

  render() {
    return (
      <Modal isOpen={this.state.isOpen} className="modal-danger">
        <ModalHeader>Not Authorized Error</ModalHeader>
        <ModalBody>
          <p>You do not have the proper permissions to perform this action, please contact the system administrator.</p>
        </ModalBody>
        <ModalFooter>
          <Button id="confirm-modal-btn" color="danger" onClick={() => {
            this.props.closeNotAuthorized()
            this.setState({isOpen: false})
          }}>OK</Button>{' '}
        </ModalFooter>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  notAuthorized: state.notAuthorized
})

export default connect(mapStateToProps, {closeNotAuthorized})(NotAuthorizedAlert)



// WEBPACK FOOTER //
// ./src/components/Alerts/NotAuthorizedAlert.js